<template>
  <nav-bar title="风险提示" />
  <Content :bottom="0">
    <div class="title">检查情况统计</div>
    <p class="checkNum">共有用户数：{{ checkNum.planCount }}</p>
    <p
      style="text-decoration: underline;color: blue"
      class="checkNum"
      @click="$router.push('/notChecked')"
    >
      未检查用户数：{{ checkNum.notCount }}
    </p>
    <div class="title">通知阅读情况</div>
    <div class="list-item" v-for="item in list" :key="item.nid">
      <p>{{ item.ntitle }}</p>
      <div>
        <span>应读：{{ item.planCount }}</span>
        <span>已读：{{ item.finishCount }}</span>
      </div>
    </div>
  </Content>
</template>

<script>
import { useStore } from 'vuex'
import { getCheckStatisticsMess, getNoticeStatisticsMess } from '@/api/salehome'
import { computed, ref } from 'vue'
import { useGetData } from '@/hooks/useGetData'
export default {
  name: 'Risk',
  setup() {
    const store = useStore()
    const departId = computed(() => store.state.roleInfo.departId)
    // 检查情况统
    const checkNum = ref({})
    useGetData(getCheckStatisticsMess, data => {
      checkNum.value = data
    })(departId.value)
    // 通知阅读情况
    const list = ref([])
    useGetData(getNoticeStatisticsMess, data => {
      list.value = data
    })(departId.value)
    return {
      checkNum,
      list
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.checkNum {
  font-size: 14px;
  padding: 0 16px;
  color: #333;
}
.list-item {
  padding: 16px;
  background-color: #fff;
  margin-bottom: 10px;
  p {
    font-size: 15px;
    font-weight: 600;
    color: #333;
  }
  span {
    font-size: 14px;
    color: #666;
    margin-right: 16px;
  }
}
</style>
